import { acquireToken } from '@ms/yammer-web-authenticators';

import type { YammerState } from '../../state/types';
import { getResourcesOrScopes } from '../getResourcesOrScopes';
import type { ApiHeaders, ApiMiddleware, ManagedApiRequest } from '../types';

const headersWithAuthorization = async (
  request: ManagedApiRequest,
  state: YammerState
): Promise<ApiHeaders | undefined> => {
  const resourcesOrScopes = getResourcesOrScopes(request, state);
  const token = await acquireToken({ scopes: resourcesOrScopes });

  return {
    ...request.headers,
    authorization: `Bearer ${token}`,
  };
};

const middleware: ApiMiddleware = async (request, state) => ({
  ...request,
  headers: await headersWithAuthorization(request, state),
});

export default middleware;
